<template>
  <div class="tab-bar-icon" :class="selected ? 'selected' : ''" @click="navigateToPage">
    <FontAwesomeIcon :icon="icon" class="icon" />
    <span class="label">{{ $te(`routes.${routeName}`) ? $t(`routes.${routeName}`) : 'MISSING ROUTE LABEL' }}</span>
  </div>
</template>

<script>
  export default {
    name: 'tab-bar-icon',
    props: {
      icon: {
        type: String,
        required: true,
      },
      routeName: {
        type: String,
        required: true,
      },
    },
    computed: {
      selected() {
        return this.routeName === this.$route.name;
      },
    },
    methods: {
      navigateToPage() {
        if (this.selected) return;
        this.$router.push({ name: this.routeName });
      },
    },
  };
</script>

<style lang="scss" scoped>
  .tab-bar-icon {
    font-size: 0.5em;

    -webkit-tap-highlight-color: transparent;
    cursor: pointer;

    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .selected {
    color: var(--color-primary);
  }

  .icon {
    font-size: 3em;
    margin-bottom: 0.25em;
  }

  .label {
    text-align: center;
  }
</style>
